module.exports = __webpack_public_path__ + "img/heating.487d7965.svg";